import { View, ActivityIndicator, Pressable } from "react-native"
import { Link } from "expo-router"
import MIcon from "@react-native-vector-icons/material-design-icons"

import { trpc } from "@src/utils/trpc"
import { Text } from "@src/components/core"
import { Header } from "@src/components/Header"
import { ar } from "@src/i18n/ar"
import { priceFromDBFormat } from "@src/utils"
import { Show, useObservable } from "@legendapp/state/react"
import { ManualBalanceTransactionModal } from "@src/components/manual-balance-transaction-modal"

export default function Balances() {
  const balance = trpc.balance.get.useQuery(undefined, { refetchOnMount: "always" })
  const balanceTransaction$ = useObservable(false)

  const header = (
    <Header
      title={ar.balances}
      right={
        <View className="h-full flex-row">
          <Pressable className="px-2 justify-center active:opacity-50 h-full" onPress={() => balanceTransaction$.set(true)}>
            <MIcon name="plus" size={24} color="black" />
          </Pressable>
          <Pressable className="px-2 justify-center active:opacity-50 h-full" onPress={() => balance.refetch()}>
            <MIcon name="refresh" size={24} color="black" />
          </Pressable>
        </View>
      }
    />
  )

  if (balance.isLoading) {
    return (
      <>
        {header}
        <ActivityIndicator className="mt-4" size="large" />
      </>
    )
  }

  return (
    <>
      {header}
      <View className="p-4 flex-1 max-w-content-wide mx-auto w-full">
        <View className="flex-row flex-wrap justify-between">
          <Link href={"/dashboard/balances/cash"} asChild>
            <Pressable className="bg-green-100 p-4 rounded items-center justify-center h-36 shadow-sm w-[48%] mb-4">
              <Text className="text-green-700 text-2xl font-bold">{ar.cash}</Text>
              <Text className="text-green-900 text-xl font-semibold mt-2">{priceFromDBFormat(balance.data?.cash ?? 0).toFixed(2)}</Text>
            </Pressable>
          </Link>

          <Link href={"/dashboard/balances/visa"} asChild>
            <Pressable className="bg-blue-100 p-4 rounded items-center justify-center h-36 shadow-sm w-[48%] mb-4">
              <Text className="text-blue-700 text-2xl font-bold">{ar.visa}</Text>
              <Text className="text-blue-900 text-xl font-semibold mt-2">{priceFromDBFormat(balance.data?.visa ?? 0).toFixed(2)}</Text>
            </Pressable>
          </Link>

          <Link href={"/dashboard/balances/wallet"} asChild>
            <Pressable className="bg-orange-100 p-4 rounded items-center justify-center h-36 shadow-sm w-[48%] mb-4">
              <Text className="text-orange-700 text-2xl font-bold">{ar.wallet}</Text>
              <Text className="text-orange-900 text-xl font-semibold mt-2">{priceFromDBFormat(balance.data?.wallet ?? 0).toFixed(2)}</Text>
            </Pressable>
          </Link>

          <Link href={"/dashboard/balances/total"} asChild>
            <Pressable className="bg-gray-800 p-4 rounded items-center justify-center h-36 shadow-sm w-[48%] mb-4">
              <Text className="text-white text-2xl font-bold">{ar.total}</Text>
              <Text className="text-gray-200 text-xl font-semibold mt-2">{priceFromDBFormat(balance.data?.total ?? 0).toFixed(2)}</Text>
            </Pressable>
          </Link>
        </View>
      </View>
      <Show if={balanceTransaction$}>
        <ManualBalanceTransactionModal onClose={() => balanceTransaction$.set(false)} />
      </Show>
    </>
  )
}
